"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useConstCallback = void 0;
var react_1 = require("react");
/**
 * Construct a function that maintains referential equality throughout lifecycle rerenders of the component. The returned function, however, will have updated closured values of each render's state.
 *
 * @example
 * ```ts
 * function MyComponent() {
 *   const [ name, setName ] = useState("jonny appleseed");
 *   const onClick = useConstCalback(() => alert(name));
 *
 *   return <Button onClick={onClick}>Say Hello</Button> // doesn't rerender when `setName` is called
 * }
 * ```
 *
 * @author Mary Strodl
 * @category Hook
 */
function useConstCallback(cb) {
    var cbRef = (0, react_1.useRef)(cb);
    cbRef.current = cb;
    return (0, react_1.useCallback)(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        return cbRef.current.apply(cbRef, __spreadArray([], __read(args), false));
    }, []);
}
exports.useConstCallback = useConstCallback;
